export default "__VITE_ASSET__D2tldT$6__"